// extracted by mini-css-extract-plugin
export var buttonContainer = "_73-1";
export var fontSizeSelect = "_73-3";
export var formatSelect = "_73-2";
export var formats = "_73-4";
export var hidden = "_73-5";
export var icon = "_73-6";
export var select = "_73-0";